module.exports = "/_next/static/images/979ce2aea92a1142ceea6da91a11c191-fees-title.svg";